import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { artists } from '../mock';
import { Award, Clock } from 'lucide-react';

const Artists = () => {
  const scrollToBooking = (artistName) => {
    const bookingSection = document.getElementById('booking');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
      // Store selected artist in sessionStorage for the booking form
      sessionStorage.setItem('selectedArtist', artistName);
    }
  };

  return (
    <section id="artists" className="py-20 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight">
            Meet Our <span className="text-red-600">Artists</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Choose from our talented team of master tattoo artists
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {artists.map((artist) =>
          <Card
            key={artist.id}
            className="artist-card bg-zinc-900 border-zinc-800 overflow-hidden group hover:border-red-600 transition-all duration-300 hover:shadow-xl hover:shadow-red-600/20 transform hover:-translate-y-2">

              <div className="relative overflow-hidden">
                <img
                src={artist.image}
                alt={artist.name}
                className="w-full h-64 object-contain bg-zinc-800 transition-transform duration-500 group-hover:scale-110" />

                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              <CardHeader className="pb-3">
                <CardTitle className="font-black uppercase !text-xl text-white">
                  {artist.name}
                </CardTitle>
                <p className="uppercase !font-sans !font-semibold !text-sm text-red-500">
                  {artist.specialty}
                </p>
              </CardHeader>

              <CardContent className="space-y-4">
                <div className="flex items-center gap-2 text-gray-400">
                  <Clock className="w-4 h-4 text-red-600" />
                  <span className="text-sm">{artist.experience} experience</span>
                </div>

                <p className="text-gray-400 text-sm leading-relaxed">
                  {artist.bio}
                </p>

                <Button
                onClick={() => scrollToBooking(artist.name)}
                className="w-full bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-wider transition-all duration-300 transform hover:scale-105">

                  Book {artist.name.split(' ')[0]}
                </Button>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </section>);

};

export default Artists;